import { Injectable } from '@angular/core';
import { BASE_API_URL, IBoondock, ICaretaker, IPhoto } from '@curbnturf/entities';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'caretaker';

@Injectable({
  providedIn: 'root',
})
export class CaretakerService {
  constructor(private cachedHttp: CachedHttpClient) {}

  saveBoondockUpdates(caretakerRequest: ICaretaker): Observable<IBoondock> {
    return this.cachedHttp.post<IBoondock>(`${API_URL}/boondock/${caretakerRequest.boondockId}`, caretakerRequest, undefined, {
      offlineCallback: () => caretakerRequest,
    });
  }

  uploadImage(boondockId: number, formData: FormData): Observable<{ id: number; photos: IPhoto[] }> {
    return this.cachedHttp.post<{ id: number; photos: IPhoto[] }>(`${API_URL}/boondock/${boondockId}/upload-image`, formData);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removePhoto(boondockId: number, key: string) {
    // @todo implement this on the server possibly.
  }

  uploadPoiImage(poiId: number, formData: FormData): Observable<{ id: number; photos: IPhoto[] }> {
    return this.cachedHttp.post<{ id: number; photos: IPhoto[] }>(`${API_URL}/poi/${poiId}/upload-image`, formData);
  }
}
